import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Skeleton = styled.div({
	flexBasis: 'auto',
	flexShrink: 0,
	backgroundColor: token('color.skeleton'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AvatarSkeleton = styled(Skeleton)({
	width: '24px',
	height: '24px',
	margin: token('space.025'),
	borderRadius: '50%',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PrimaryTextSkeleton = styled(Skeleton)({
	width: '160px',
	height: '14px',
	borderRadius: token('border.radius.100'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SecondaryTextSkeleton = styled(Skeleton)({
	width: '48px',
	height: '14px',
	borderRadius: token('border.radius.100'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PanelHeadingSkeleton = styled(Skeleton)({
	width: '12px',
	height: '12px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PanelHeadingSkeleton2 = styled(Skeleton)({
	width: '80px',
	height: '16px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PanelHeadingSkeleton3 = styled(Skeleton)({
	width: '16px',
	height: '16px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const UserProgressSkeleton = styled(Skeleton)({
	width: '40px',
	height: '28px',
	borderRadius: token('border.radius.100'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const MentionedTextSkeleton = styled(Skeleton)({
	width: '120px',
	height: '20px',
	borderRadius: token('border.radius.100'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ProgressBarSkeleton = styled(Skeleton)({
	width: '360px',
	height: '6px',
	borderRadius: token('border.radius.100'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AnalyticsDialogFooterSkeleton = styled(Skeleton)({
	width: '80px',
	height: '20px',
});
